import React from "react";
import { Link } from "react-router-dom";

const ListMenu = (props) => {
	const href = props.items.gnb.href;
	const type = props.items.gnb.link;
	const items = props.items;

	const handleLinkClicked = () => {
		props.setMenu(!props.isMenuClicked);
	};

	return (
		<li>
			{href ? (
				<a onClick={handleLinkClicked} href={href} target={"_blank"}>
					{items.gnb.name}
				</a>
			) : type ? (
				<Link onClick={handleLinkClicked} id={items.id} to={items.gnb.link}>
					{items.gnb.name}
				</Link>
			) : (
				<p onClick={props.lnbClickHandler} id={items.id}>
					{items.gnb.name}
				</p>
			)}

			<div className={props.active ? "wrap-lnb lnb-show" : "wrap-lnb"}>
				<div className="lnb-info">
					<p className="lnb-haeder">{items.gnb.name}</p>

					{!items.lnb ? (
						""
					) : (
						<ul className="lnb-mobile">
							{items.lnb.map((el, index) => {
								return (
									<li key={el.name + index}>
										<Link onClick={handleLinkClicked} to={el.link}>
											{el.name}
										</Link>
									</li>
								);
							})}
						</ul>
					)}
				</div>
			</div>
		</li>
	);
};

export default ListMenu;
